(function(ns) {
	"use strict";

	var util = ns.util;

	util.component("root-view", {
		props: ["valid_post", "action"],
		data: function() {
			return {
				state: ns.store.state,
				entry: ns.store.entry,
				entry_error: ns.store.entry_error,
			};
		},
		methods: {
			submit: function() {
				var me = this;

				me.state.loading = true;
				me.state.saveError = false;

				fetch(me.action + "?" + Date.now(), {
					method: "POST",
					headers: {
						"Content-Type": "application/json"
					},
					body: JSON.stringify({
						valid_post: me.valid_post,
						entry: me.entry
					}),
					credentials: "same-origin"
				}).then(function(response) {
					return response.json();
				}).then(function(result) {
					if (!result.success) {
						var error = new Error("Failed to create entry.");
						error.result = result;
						throw error;
					}
					me.state.loading = false;
					me.state.completed = true;
					ns.clearState();
					window.scrollTo(0, 40);
				}).catch(function(e) {
					console.log("データを登録できませんでした", e);
					me.state.loading = false;
					me.state.saveError = true;

					if (e.result && e.result.errors) {
						Object.keys(e.result.errors).forEach(function(field) {
							console.log(field, e.result.errors[field]);
							Vue.set(me.entry_error, field, e.result.errors[field]);
						});
					}
				});
			},
			reset: function() {
				this.state.loading = false;
				this.state.saveError = false;
				this.state.completed = false;
				ns.store.resetEntry();
				ns.clearState();
			},
		},
		watch: {
			entry: {
				deep: true,
				handler: function() {
					ns.saveState(); // 変更があるたびに入力を保存する
				}
			}
		}
	});

})(UE);
